import { render } from "./BottomAppBar.vue?vue&type=template&id=8aee3dc4&scoped=true"
import script from "./BottomAppBar.vue?vue&type=script&lang=js"
export * from "./BottomAppBar.vue?vue&type=script&lang=js"

import "./BottomAppBar.vue?vue&type=style&index=0&id=8aee3dc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8aee3dc4"]])

export default __exports__